import { useContext } from "react";
import { DataContext } from "../context/DataContext";

// =============================================================================
// useData - DATACONTEXT CONSUMER
// =============================================================================
// PURPOSE: Backward-compatible API that wraps domain-separated contexts.
//
// REQUIREMENTS:
// - Used by legacy components (OperationsDashboard, etc.)
// - Provides unified interface to TransactionContext, TeamContext, ClientPortalContext
//
// KEY DECISIONS:
// - DataContext orchestrates domain contexts and manages org selection
// - Kept for backward compatibility - new code should use data-fetching hooks
// =============================================================================

export const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};
